import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/phone-icon.svg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"30px","width":"30px"},
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "fs-5 ml-3" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col form-label" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col form-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("strong", _hoisted_4, _toDisplayString(_ctx.number), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.firstRow), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.secondRow), 1)
      ])
    ])
  ]))
}